import { alignSidenotesToAnchorLinks } from '../../shared/sidenotes';

// Auto-run (or invoke manually where you initialize front-end scripts)
document.addEventListener('DOMContentLoaded', alignSidenotesToAnchorLinks);
